// eslint-disable-next-line no-restricted-imports
import { OrderCommonDirectionEnum } from '@eih-netbroker/api-order';

export const TradeType = OrderCommonDirectionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TradeType = (typeof TradeType)[keyof typeof TradeType];
